import type { SupabaseClient } from '@supabase/supabase-js';

export async function confirmSignup(auth: SupabaseClient['auth'], href: string): Promise<void> {
  const url = new URL(href);
  const params = new URLSearchParams(url.search);
  new URLSearchParams(url.hash.slice(1)).forEach((value, key) => params.set(key, value));
  if (params.has('error') || params.has('error_code')) throw new Error('Confirmation link rejected');
  const type = params.get('type') || 'signup';
  if (!['signup', 'email'].includes(type)) throw new Error('Unexpected confirmation type');
  const tokenHash = params.get('token_hash') || params.get('token');
  if (tokenHash) {
    const { error } = await auth.verifyOtp({ token_hash: tokenHash, type: type as 'signup' | 'email' });
    if (error) throw error;
  } else {
    // getSession waits for the SDK to consume implicit redirect tokens.
    // Do not setSession again with the same single-use refresh token.
    const { data, error } = await auth.getSession();
    if (error) throw error;
    if (!data.session) throw new Error('No confirmation session');
  }
  // Validate with the server instead of inferring confirmation from URL presence.
  const { data, error } = await auth.getUser();
  if (error || !data.user?.email_confirmed_at) throw new Error('Email is not confirmed');
}
